import { createFileRoute } from "@tanstack/react-router";

import { ProfileCareplans } from "@/components/profiles/profile-careplans";

const ProfileCareplansPage = () => {
  return <ProfileCareplans />;
};

export const Route = createFileRoute("/_private/profiles/$id/careplans/")({
  component: ProfileCareplansPage,
});
